/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReverseDirection = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m6 7.586 3.707 3.707-1.414 1.414L7 11.415V15c0 2.764 2.236 5 5 5l.182-.006a8.25 8.25 0 0 0 .904-.105 8.932 8.932 0 0 0 2.13-.625l.337-.158.894 1.788a10.69 10.69 0 0 1-3.033.967A9.1 9.1 0 0 1 12 22a6.997 6.997 0 0 1-6.996-6.76L5 15v-3.585l-1.293 1.292-1.414-1.414zM12 4l-.182.006a8.443 8.443 0 0 0-.904.105 8.932 8.932 0 0 0-2.13.625l-.337.158-.894-1.788a10.712 10.712 0 0 1 3.033-.967A9.1 9.1 0 0 1 12 2a6.997 6.997 0 0 1 6.996 6.76L19 9v3.585l1.293-1.292 1.414 1.414L18 16.414l-3.707-3.707 1.414-1.414L17 12.585V9c0-2.764-2.236-5-5-5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgReverseDirection as ReverseDirection };
